import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

export const VillageToBMI = {
  label: "鄉鎮 vs BMI",
  key: "VillageToBMI",
  path: "BMI/VillageToBMI",
  api: "TCS_V_BMIItemsV",
  render: (options) => <Diagram.BMI.VillageToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
